import React, { useState, useEffect } from "react";
import { Button, TextField, Grid, FormControl, Select, MenuItem, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Checkbox, Paper } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import DataTable from "examples/Tables/DataTable";
import authorsTableData from "layouts/Attendance-management/data";
import Notification from "examples/Notifications";
import meetingServices from "services/meeting-services";
import { MarkButton } from "layouts/common/buttons";

const AttendanceManagement = () => {
    const [attendance, setAttendance] = useState([]);
    const [notification, setNotification] = useState(false);
    const { columns, rows } = authorsTableData(attendance);

    useEffect(() => {
        getMeetings();
    }, []);

    const getMeetings = async () => {
        const meetingData = await meetingServices.getattendancemeeting();
        console.log("meetingData", meetingData);
        if (meetingData.success && meetingData.meetings) {
            const formattedMeetings = meetingData.meetings.map(meeting => ({
                ...meeting,
                date: meeting.date ? new Date(meeting.date).toLocaleDateString("en-CA") : ""
            }));
            setAttendance(formattedMeetings);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info"
                                display="flex" justifyContent="space-between" alignItems="center">
                                <MDTypography variant="h6" color="white"> Meetings </MDTypography>
                                <MDBox display="flex" alignItems="center" justifyContent="space-between" >
                                    <MarkButton link="/attendance/mark" />
                                </MDBox>
                            </MDBox>
                            <Notification notification={notification} setNotification={setNotification} />
                            <MDBox pt={3}>
                                <DataTable table={{ columns, rows }} isSorted={true} entriesPerPage={false} showTotalEntries={false} noEndBorder />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>

    );
};

export default AttendanceManagement;